import React from "react";
import { Helmet } from "react-helmet-async";

import GlobalHero from "../components/global/GlobalHero";
import BlogCard from "../components/blog/BlogCard";

import { blogSections } from "../components/blog/blogSections";
import { blogPosts } from "../components/blog/blogPosts";

const Blog = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "hero":
        return (
          <GlobalHero
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            variant="blog"
          />
        );

      case "posts":
        return (
          <section key={index} className="container-fluide mt-5 py-5">
            <div className="container">
              <div className="home-fleet" data-aos="zoom-in" data-aos-delay="200">
                {blogPosts.map((post) => (
                  <BlogCard
                    key={post.slug}
                    slug={post.slug}
                    title={post.title}
                    image={post.image}
                    excerpt={post.excerpt}
                  />
                ))}
              </div>
            </div>
          </section>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Cold Chain Logistics Insights &amp; Guides | Chiller Fleet Transport</title>
        <meta name="description" content="Practical guides on refrigerated transport across the UAE — delivery conditions, cold chain compliance, vehicle selection, and route planning from an operating fleet." />
        <meta property="og:title" content="Cold Chain Logistics Insights & Guides | Chiller Fleet Transport" />
        <meta property="og:description" content="Practical guides on refrigerated transport across the UAE — delivery conditions, cold chain compliance, vehicle selection, and route planning from an operating fleet." />
        <link rel="canonical" href="https://chillerfleet.com/blog" />
        <meta property="og:url" content="https://chillerfleet.com/blog" />
        <meta name="twitter:title" content="Cold Chain Logistics Insights & Guides | Chiller Fleet Transport" />
        <meta name="twitter:description" content="Practical guides on refrigerated transport across the UAE — delivery conditions, cold chain compliance, vehicle selection, and route planning from an operating fleet." />
      </Helmet>

      {blogSections.map(renderSection)}
    </>
  );
};

export default Blog;
